import { createSlice } from '@reduxjs/toolkit'
import { getCardShippingAddressId } from 'utils/card'

const initialState = {
  // Flow input params passed through query string
  flowInputParams: {
    // Replace card reason
    reason: null,
    // Address Id from address flow
    addressId: null,
  },

  // Replace card form
  replaceCardForm: {
    // Selected replace card reason
    selectedReason: null,

    // Shipping Address Id, will read from last shipping address Id
    // if address has been removed will fallback to billing address Id
    shippingAddressId: null,
  },

  // Card details response returned by CCLS API
  card: null,

  // New Card when user reports card lost and replacement card is returned
  newCard: null,

  // List of addresses returned by CCLS API
  addresses: null,

  // Report lost/stolen or Reissue API call result
  replaceCardResult: null,

  // is Digital Only Card
  isDigitalOnlyCard: null,
}

const replaceCardSlice = createSlice({
  name: 'replaceCard',
  initialState,
  reducers: {
    initFlowInputParams(state, action) {
      const { reason, addressId } = action.payload || {}
      state.flowInputParams.reason = reason
      state.flowInputParams.addressId = addressId
      state.replaceCardForm.selectedReason = reason
    },
    initReplaceCard(state, action) {
      const { card, addresses } = action.payload || {}
      state.card = card
      state.addresses = addresses
      state.replaceCardForm.shippingAddressId = getCardShippingAddressId(card, addresses, {
        fallbackToBilling: true,
      })
    },
    updateSelectedReason(state, action) {
      const reason = action.payload
      state.replaceCardForm.selectedReason = reason
    },
    updateIsDigitalOnlyCard(state, action) {
      state.isDigitalOnlyCard = action.payload
    },
    changeShippingAddress(state, action) {
      const { addresses, shippingAddressId } = action.payload
      state.shippingAddressId = shippingAddressId

      // If new addresses are added
      if (addresses) {
        state.addresses = addresses
      }
    },
    updateReplaceCardResult(state, action) {
      const { card, newCard } = action.payload || {}
      state.card = card
      state.newCard = newCard
      state.replaceCardResult = action.payload
    },
    resetReplaceCard(state) {
      Object.assign(state, initialState)
    },
  },
})

export const selectIsDigitalOnlyCard = (state) => state.replaceCard?.isDigitalOnlyCard

export const {
  initFlowInputParams,
  initReplaceCard,
  updateSelectedReason,
  updateIsDigitalOnlyCard,
  updateReplaceCardResult,
  resetReplaceCard,
} = replaceCardSlice.actions

export default replaceCardSlice.reducer
